import { useCallback, useState } from "react";
import { useQuery } from "react-query";

import { Video, VideoFile, getVideoFiles } from "@/api";
import {
  HOURS_3_IN_MS,
  VIDEO_TYPE_AUDIO,
  VIDEO_TYPE_VIDEO,
} from "@/const.ts";

import { checkVideoUrl } from "@/utils";

export const useVideoFiles = ({
  video,
  videoId,
}: {
  videoId?: number;
  video?: Video;
}) => {

  const live = !!video?.Properties?.LiveEventStartDate;
  const liveEnded = !!video?.Properties?.LiveEventEnded;
  const type = video?.Type || VIDEO_TYPE_VIDEO; // Assume required until video loaded
  const [liveStatus, setLiveStatus] = useState<string>();

  const query = useQuery<VideoFile[]>(
    ["videofiles", videoId],
    async () => {
      return getVideoFiles(videoId!);
    },
    {
      // Don't even try get data if user does not have access to video, server will 403 anyway
      // Don't try to get ended livestreams
      enabled:
        !!videoId &&
        (!live || !liveEnded) &&
        [VIDEO_TYPE_AUDIO, VIDEO_TYPE_VIDEO].includes(type ?? ""),
      staleTime: HOURS_3_IN_MS,
    },
  );

  const isLive = useCallback(async () => {
    const hlsFile = query.data?.find((f) => !!f.Type && f.Type === "HLS");
    if (hlsFile) {
      const { Status = "", URL } = hlsFile;

      setLiveStatus(Status);

      return await checkVideoUrl(URL);
    }
    return false;
  }, [query.data]);

  return { ...query, isLive, liveStatus };
};
